module.exports = __webpack_public_path__ + "img/logo.aa26dc68.png";